import { SvgIconProps } from "@mui/material";
import logo_gray from "./logo_gray.svg";
import logo_white from "./logo_white.svg";
export const Logo_SY = logo_gray;
export const Logo_SY_white = logo_white;

import {
  SvgAnalytics,
  SvgAssets,
  SvgConfiguration,
  SvgMeetings,
  SvgReports,
  SvgWarning,
  SvgAddFilter,
  SvgSortPriorityAsc,
  SvgSortPriorityDesc,
  SvgSortCountAsc,
  SvgSortCountDesc,
  SvgCalendar,
  SvgAuditTrails,
  SvgRemote,
  SvgScheduleMeeting,
  SvgCamundaIcon,
  SvgDeviceManagement,
  SvgSNMPParameters,
  SvgSIPRegistrar,
  SvgDashboardIcon,
  SvgAlexa,
  SvgCamera,
  SvgCodec,
  SvgCoffee,
  SvgComputer,
  SvgController,
  SvgHomepod,
  SvgLaptop,
  SvgLights,
  SvgMic,
  SvgMonitor,
  SvgOccSensor,
  SvgPhone,
  SvgPlug,
  SvgPower,
  SvgPowerswitch,
  SvgProjector,
  SvgShades,
  SvgSpeaker,
  SvgSurveillance,
  SvgSwitch,
  SvgTablet,
  SvgTemperature,
  SvgRoom,
  SvgH323Gatekeeper,
  SvgAdvancedPropertiesIcon,
  SvgSymphony,
  SvgUnknownProducer,
  SvgElogRounded,
  SvgSortAZ,
  SvgSortZA,
  SvgSentimentSatisfiedAlt,
  SvgMonitorDevice,
  SvgFavoriteControls,
  SvgVIP,
  SvgTicket,
  SvgExternalVideoCloud,
  SvgAddColumn,
  SvgCertificationExpired,
  SvgCertificationAboutToExpire,
  SvgMappingColumn,
  SvgRoomID,
  SvgLogout,
  SvgRefreshPosition,
  SvgDMCA,
  SvgCSV,
} from "./svgs";
export const Analytics = () => SvgAnalytics;
export const Assets = () => SvgAssets;
export const Configuration = () => SvgConfiguration;
export const Meetings = () => SvgMeetings;
export const Reports = () => SvgReports;
export const Warning = () => SvgWarning;
export const AddFilter = () => SvgAddFilter;
export const SortPriorityAsc = () => SvgSortPriorityAsc;
export const SortPriorityDesc = () => SvgSortPriorityDesc;
export const SortCountAsc = () => SvgSortCountAsc;
export const SortCountDesc = () => SvgSortCountDesc;
export const Calendar = () => SvgCalendar;
export const AuditTrails = () => SvgAuditTrails;
export const Remote = () => SvgRemote;
export const ScheduleMeeting = () => SvgScheduleMeeting;
export const CamundaIcon = () => SvgCamundaIcon;
export const DeviceManagement = () => SvgDeviceManagement;
export const SNMPParameters = () => SvgSNMPParameters;
export const H323Gatekeeper = () => SvgH323Gatekeeper;
export const SIPRegistrar = () => SvgSIPRegistrar;
export const DashboardIcon = () => SvgDashboardIcon;
export const Alexa = () => SvgAlexa;
export const Camera = () => SvgCamera;
export const Codec = () => SvgCodec;
export const Coffee = () => SvgCoffee;
export const Computer = () => SvgComputer;
export const Controller = () => SvgController;
export const Homepod = () => SvgHomepod;
export const Laptop = () => SvgLaptop;
export const Lights = () => SvgLights;
export const Mic = () => SvgMic;
export const Monitor = () => SvgMonitor;
export const OccSensor = () => SvgOccSensor;
export const Phone = () => SvgPhone;
export const Plug = () => SvgPlug;
export const Power = () => SvgPower;
export const Powerswitch = () => SvgPowerswitch;
export const Projector = () => SvgProjector;
export const Shades = () => SvgShades;
export const Speaker = () => SvgSpeaker;
export const Surveillance = () => SvgSurveillance;
export const Switch = () => SvgSwitch;
export const Tablet = () => SvgTablet;
export const Temperature = () => SvgTemperature;
export const Room = () => SvgRoom;
export const AdvancedPropertiesIcon = () => SvgAdvancedPropertiesIcon;
export const SymphonyIcon = SvgSymphony;
export const UnknownProducer = () => SvgUnknownProducer;
export const ElogRounded = () => SvgElogRounded;
export const SortAZ = () => SvgSortAZ;
export const SortZA = () => SvgSortZA;
export const SentimentSatisfiedAlt = () => SvgSentimentSatisfiedAlt;
export const MonitorDevice = () => SvgMonitorDevice;
export const FavoriteControls = () => SvgFavoriteControls;
export const VIP = () => SvgVIP;
export const Ticket = () => SvgTicket;
export const ExternalVideoCloud = () => SvgExternalVideoCloud;
export const AddColumn = () => SvgAddColumn;
export const CertificationExpired = (props: SvgIconProps) =>
  SvgCertificationExpired(props);
export const CertificationAboutToExpire = (props: SvgIconProps) =>
  SvgCertificationAboutToExpire(props);
export const AddMappingColumn = () => SvgMappingColumn;
export const RoomID = () => SvgRoomID;
export const Logout = () => SvgLogout;
export const RefreshPosition = () => SvgRefreshPosition;
export const IconDMCA = SvgDMCA;
export const CSV = () => SvgCSV;
